import { Button, Card, Form, Input, message, Tag } from 'antd';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import VerifyOTP from '../verify-otp/verifyOtp';
import { ArrowLeftOutlined, ArrowRightOutlined, EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { validatePassword } from '../../../../common/commonfunctions';
import './forgotPassword.css';
import { easeInOut, motion } from 'framer-motion';
import SuccessModel from '../../../child-components/success-model/successModal';
import { useDispatch, useSelector } from 'react-redux';
import { ForgotPasswordApi, resetForgotPassword } from '../../../../redux/features/auth/ForgotPassword';
import { encryptInput } from '../../../../shared/shared-functions';
import { resetVerifyOtp } from '../../../../redux/features/auth/VerifyOTP';
import { RiContactsLine, RiLockPasswordLine } from 'react-icons/ri';
import { useLogType } from '../../../../context/LogTypeContext';

const ForgotPassword = () => {
	const navigate = useNavigate(),
		[form] = Form.useForm(),
		[boolForgotMdl, setBoolForgotMdl] = useState(true),
		[newPassword, setNewPassword] = useState(''),
		[confirmPassword, setConfirmPassword] = useState(''),
		[changeVerifyMdlDis, setChangeVerifyMdlDis] = useState<boolean>(false),
		[successMdlDis, setSuccessMdlDis] = useState<boolean>(false),
		[isButtonDisabled, setIsButtonDisabled] = useState(true),
		{ forgotPassRes, forgotPassLoad } = useSelector((state: any) => state.forgotPassword),
		{ verifyOtpRes, verifyOtpLoad } = useSelector((state: any) => state.verifyOtp),
		[userName, setUserName] = useState(),
		dispatch = useDispatch(),
		token = forgotPassRes?.data?.accessToken;
	const changeVerifyMdlOpen = (boolVal: boolean) => {
		setChangeVerifyMdlDis(boolVal);
		dispatch(resetForgotPassword());
	};
	const successMdlOpen = (boolVal: boolean) => {
		setSuccessMdlDis(boolVal);
	};

	const onFinishNewPassword = (values: any) => {
		setIsResendOtp(false);
		const formData = new URLSearchParams();
		formData.append('Password', encryptInput(values.NewPassword));

		// Call API with token
		dispatch(
			ForgotPasswordApi({
				input: formData,
				token: {
					CustomToken: verifyOtpRes?.data
				}
			})
		);
	};

	const onFinishForgotPassword = (values: any) => {	
		const { userName, phonenumber,UserType} = values;
		const formData = new URLSearchParams();
		if (userName) {
			formData.append('Username', userName);
			formData.append('UserType', 'SystemUser');
			setUserName(userName);
		} else if (phonenumber) {
			formData.append('PhoneNumber', phonenumber);
			formData.append('UserType', 'Influencer');
			setUserName(phonenumber);
		}
		dispatch(ForgotPasswordApi({ input: formData }));
		
	};

	const handlePasswordChange = (value: string) => {
		setNewPassword(value);
		updateButtonState(value, confirmPassword);
	};

	const handleConfirmPasswordChange = (value: string) => {
		setConfirmPassword(value);
		updateButtonState(newPassword, value);
	};
	const updateButtonState = (password: string, confirm: string) => {
		const isValid = password && confirm && password === confirm;
		setIsButtonDisabled(!isValid);
	};

	const resendOtpToggle = (boolVal: boolean) => {
		setIsResendOtp(boolVal);
	};

	useEffect(() => {
		if (!forgotPassLoad && forgotPassRes && forgotPassRes?.statusCode === 200) {
			if (boolForgotMdl) {
				setChangeVerifyMdlDis(true);
			} else {
				setSuccessMdlDis(true);
			}
			
			if (changeVerifyMdlDis) {
			
					message.success('OTP sent successfully!');
			
			}
			// if (changeVerifyMdlDis) {
			// 	if(isResendOtp){
			// 		message.success('OTP resent successfully!');
			// 	}else{
			// 		message.success('OTP sent successfully!');
			// 	}
			// }
		} else if (!forgotPassLoad && forgotPassRes && forgotPassRes?.statusCode === 400) {
			message.warning(forgotPassRes?.message);
			dispatch(resetForgotPassword());
		} else if (!forgotPassLoad && forgotPassRes && forgotPassRes?.statusCode === 500) {
			message.error(forgotPassRes?.message);
			dispatch(resetForgotPassword());
		}
	}, [forgotPassRes, forgotPassLoad]);

	const successTxt = (
		<div style={{ textAlign: 'center' }}>
			<h2 style={{ color: '#0fce6e' }}>Password Changed Successfully</h2>
			<p style={{ marginBottom: '20px', fontSize: '13px', color: '#6c757d' }}>
				Your account password has been successfully changed. Please use your new password to login!
			</p>
		</div>
	);

	useEffect(() => {
		if (!verifyOtpLoad && verifyOtpRes && verifyOtpRes?.statusCode === 200) {
			setBoolForgotMdl(false);
			setChangeVerifyMdlDis(false);
		} else if (!verifyOtpLoad && verifyOtpRes && verifyOtpRes?.statusCode === 400) {
			message.warning(verifyOtpRes?.message);
			dispatch(resetVerifyOtp());
		} else if (!verifyOtpLoad && verifyOtpRes && verifyOtpRes?.statusCode === 500) {
			message.error(verifyOtpRes?.message);
			dispatch(resetVerifyOtp());
		}
	}, [verifyOtpRes, verifyOtpLoad]);

	// const [logtype, setLogtype] = useState<any>('User');
		const { logtype, setLogtype ,isResendOtp, setIsResendOtp,} = useLogType();	
	

	const LoginToggle = (typeofLog: any) => {
		setLogtype(typeofLog);
	};

	return (
		<div className="forgotPassMainDiv">
			<div className="header">
				<div className="logo-container">
					<img width={100} src="/assets/images/logo.png" alt="Prowess" title="Prowess" />
				</div>
				<Button
					onClick={() => {
						navigate('/');
						dispatch(resetVerifyOtp());
						dispatch(resetForgotPassword());
					}}
					size="small"
					// type="primary"
					style={{ marginBottom: '0px',backgroundColor:"black !important" ,color:"white !important" }}
				>
					Login
				</Button>
			</div>
			<div className="mainForgotPass-page">
				{boolForgotMdl && (
					<motion.div
						className="forgotPass-motion"
						initial={{ x: 400, opacity: 0.5 }}
						animate={{ x: 0, opacity: 1 }}
						transition={{ duration: 1, ease: easeInOut }}
					>
						<Card className="forgotCard" style={{ fontFamily: 'NoirPro' }}>
							<div className="card-content">
								<div className="forgotCard-left">
									<div>
										<span className="changeSubLine" style={{ marginBottom: '5px', fontWeight: 'bold' }}>
											<p style={{ textAlign: 'center', fontSize: '18px',color:"black" }} className="gx-link">
												Forgot Your Password?
											</p>
										</span>
										<p className="changeSubLine" style={{ textAlign: 'center', marginBottom: '20px' }}>
											No problem! Resetting your password is quick and easy. Just enter the phone number you registered with.
										</p>
										{logtype === 'Influencer' ? (
											// <p
											// 	style={{ marginTop: '3px', width: '200px', textAlign: 'end' }}
											// 	className="gx-fs-sm gx-p-0 gx-link"
											// 	onClick={() => LoginToggle('User')}
											// >
											// 	Forgot as User?
											// </p>
											<Tag color="black"  className='gx-fs-sm gx-mr-4 cursor-pointer' onClick={() => LoginToggle('SystemUser')}>Forgot as User?</Tag>
										) : (
											// <p
											// 	style={{ marginTop: '3px', width: '200px', textAlign: 'end' }}
											// 	className="gx-fs-sm  gx-p-0 gx-link"
											// 	onClick={() => LoginToggle('Inf')}
											// >
											// 	Forgot as Influencer?
											// </p>
											<Tag color="black"  className='gx-fs-sm gx-mr-4 cursor-pointer'  onClick={() => LoginToggle('Influencer')}>Forgot as Influencer?</Tag>
										)}
									</div>
									<Form layout="vertical" form={form} onFinish={onFinishForgotPassword}>
										{logtype === 'SystemUser' ? (
											<motion.div initial={{ x: 200, opacity: 0.2 }} animate={{ x: 0, opacity: 1 }} transition={{ duration: 1, ease: easeInOut }}>
												<Form.Item
													label="User Name"
													name="userName"
													rules={[
														{
															required: true,
															message: 'Please enter user name.'
														}
													]}
												>
													<Input
														maxLength={250}
														prefix={<RiContactsLine />}
														style={{ height: '40px' }}
														placeholder="Enter User Name"
														id="basic_email"
													/>
												</Form.Item>
											</motion.div>
										) : (
											<Form.Item
												label="Phone number"
												name="phonenumber"
												rules={[
													{
														required: true,
														message: 'Please enter Phone Number'
													},
													{
														pattern: /^[0-9]{10,12}$/,
														message: 'Phone number must be 10-12 digits'
													}
												]}
											>
												<Input placeholder="Enter your Phone Number" prefix={<RiContactsLine />} size="large" maxLength={250} />
											</Form.Item>
										)}

										<p className="changeSubLine" style={{ textAlign: 'center', marginTop: '-8px', marginBottom: '20px' }}>
											We will send a verification code to this phone number if it matches an existing account.
										</p>
										<Form.Item>
											<Button
												// type="primary"
												htmlType="submit"
												style={{
													borderRadius: '5px',
													marginBottom: '10px',
													backgroundColor:"black !important" ,color:"white !important"
												}}
												block
											>
												Next <ArrowRightOutlined />
											</Button>
										</Form.Item>
									</Form>
									<div style={{ textAlign: 'center' }}>
										<Link to="/">
											<ArrowLeftOutlined /> Back to Login
										</Link>
									</div>
								</div>

								{/* Right Section */}
								<div className="forgotCard-right">
									<img alt="" src="/assets/images/forgotPassword.png" className="promo-illustration" />
								</div>
							</div>
						</Card>
					</motion.div>
				)}

				{/* Change password */}
				{!boolForgotMdl && (
					<motion.div
						className="forgotPass-motion"
						initial={{ x: 400, opacity: 0.5 }}
						animate={{ x: 0, opacity: 1 }}
						transition={{ duration: 1, ease: easeInOut }}
					>
						<Card className="forgotCard">
							<div className="card-content">
								<div className="forgotCard-left">
									<div>
										<span className="changeSubLine" style={{ marginBottom: '5px', fontWeight: 'bold' }}>
											<p style={{ textAlign: 'center', fontSize: '18px',color:"black" }} className="gx-link">
												Choose A New Password
											</p>
										</span>
										<p style={{ marginBottom: '20px', fontSize: '12px', color: '#6c757d' }}>
											To secure your account, choose a strong password you haven't used before and is at least 8 characters long.
										</p>
									</div>
									<Form form={form} onFinish={onFinishNewPassword} layout="vertical">
										<div style={{ marginBottom: '16px' }}>
											<Form.Item
												label="Password"
												name="NewPassword"
												rules={[{ validator: validatePassword, required: true }]}
												className="gx-p-0 gx-m-0"
											>
												<Input.Password
													prefix={<RiLockPasswordLine />}
													placeholder="Enter new password"
													value={newPassword}
													onChange={(e) => handlePasswordChange(e.target.value)}
													iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
													onKeyDown={(event: any) => {
														const input = event.target.value;
														if (event.key === ' ' && input.length === 0) {
															event.preventDefault();
														}
													}}
												/>
											</Form.Item>
										</div>
										<div style={{ marginBottom: '16px' }}>
											<Form.Item
												label="Confirm Password"
												name="ConfirmPassword"
												dependencies={['NewPassword']}
												rules={[
													{
														required: true,
														message: 'Please confirm password.'
													},
													({ getFieldValue }) => ({
														validator(_, value) {
															if (!value || getFieldValue('NewPassword') === value) {
																return Promise.resolve();
															}
															return Promise.reject(new Error('The passwords do not match.'));
														}
													})
												]}
												className="gx-p-0 gx-m-0"
											>
												<Input.Password
													prefix={<RiLockPasswordLine />}
													placeholder="Confirm new password"
													value={confirmPassword}
													onChange={(e) => handleConfirmPasswordChange(e.target.value)}
													iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
													onKeyDown={(event: any) => {
														const input = event.target.value;
														if (event.key === ' ' && input.length === 0) {
															event.preventDefault();
														}
													}}
												/>
											</Form.Item>
										</div>
										<div style={{ marginBottom: '16px' }}>
											<Form.Item>
												<Button
													// type="primary"
													htmlType="submit"
													// disabled={isButtonDisabled}
													style={{
														marginTop: '10px',
														backgroundColor:"black !important" ,color:"white !important"
													}}
													block
												>
													Reset Password
												</Button>
											</Form.Item>
										</div>
									</Form>
								</div>

								{/* Right Section*/}
								<div className="forgotCard-right">
									<img alt="" src="/assets/images/newPassword (2).png" className="promo-illustration" />
								</div>
							</div>
						</Card>
					</motion.div>
				)}
			</div>
			{/* {changeVerifyMdlDis && <VerifyOTP userName={userName} accessToken={token} disMdl={true} trigger={changeVerifyMdlOpen} />} */}
			{changeVerifyMdlDis && <VerifyOTP userName={userName} accessToken={token} disMdl={false} trigger={changeVerifyMdlOpen} resendOtpToggle={resendOtpToggle} />}
			{successMdlDis && <SuccessModel title={successTxt} redirection={'login'} disSuccessMdl={true} triggerSuccess={successMdlOpen} />}
		</div>
	);
};
export default ForgotPassword;
